import React from 'react';
import isObject from 'lodash/isObject';
import { useSelector } from 'react-redux';
import { CloseIcon, Edit, Plus } from '@yme/assets/icons';
import { Button, CONTAINED_VARIANT, GHOST_VARIANT, ICON_ONLY, SIZE_40, TRAILING_ICON, } from '@yme/atoms/button';
import { GridWrapper } from '@yme/atoms/grid';
import { Tooltip, TooltipPlacement } from '@yme/atoms/tooltip';
import { useWindowSize } from '@yme/hooks/index';
import { getRTL } from '@yme/selectors/index';
import { useTranslation } from '@yme/services/i18n';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { CheckboxStyled, RegularTextLevel3Styled } from './styled';
import { useCompatibilityPanel } from './useCompatibilityPanel';
export function CompatibilityPanel(props) {
    const { selectModelProps, dataTestId, compatiblePanelAPI } = props;
    const isRightToLeft = useSelector(getRTL);
    const { isMobileView } = useWindowSize();
    const { isCheckboxChecked, compatibleProduct, onApplyProductToFilter, modalLabels, openSelectModelModal, onChangeCheckbox, onResetProduct, } = useCompatibilityPanel({
        selectModelProps,
        compatiblePanelAPI,
    });
    const { t } = useTranslation();
    if (!selectModelProps?.endpoints) {
        return null;
    }
    const commonPaddingValue = !isMobileView ? '18px' : '24px';
    // Select mode (mobile/tablet/desktop views)
    if (!compatibleProduct) {
        return (React.createElement(FlexWrapper, { bg: colorCoreWhite1000, isRightToLeft: isRightToLeft },
            React.createElement(GridWrapper, { containerProps: {
                    width: '100%',
                    dataTestId: `${dataTestId}__Select-mode`,
                } },
                React.createElement(FlexWrapper, { gap: "16px", alignItems: "center", pt: commonPaddingValue, pb: commonPaddingValue, flexDirection: isMobileView ? 'column' : 'row', justifyContent: isMobileView ? undefined : 'space-between', isFullWidth: true },
                    React.createElement(RegularTextLevel3, { as: "span" }, t('productsGrid_selectYourYamaha_description')),
                    React.createElement(Button, { width: !isMobileView ? 'auto' : '100%', label: modalLabels.selectModelLabel, size: SIZE_40, hasIconButton: TRAILING_ICON, iconComponent: Plus, buttonVariant: CONTAINED_VARIANT, isRightToLeft: isRightToLeft, onClick: openSelectModelModal })))));
    }
    // Edit mode (mobile/tablet/desktop views)
    if (compatibleProduct && isObject(compatibleProduct)) {
        const productName = compatibleProduct?.productLastYear
            ? `${compatibleProduct?.productLastYear} ${compatibleProduct?.name}`
            : compatibleProduct?.name;
        // TODO: (D.K) Investigate case with condition productLatestYear === currentYear
        // const productName =
        //   compatibleProduct?.isLatestModel && compatibleProduct?.productLastYear
        //     ? `${compatibleProduct?.productLastYear} ${compatibleProduct?.name}`
        //     : compatibleProduct?.name;
        return (React.createElement(FlexWrapper, { bg: colorCoreWhite1000, isRightToLeft: isRightToLeft },
            React.createElement(GridWrapper, { containerProps: {
                    width: '100%',
                    dataTestId: `${dataTestId}__Edit-mode`,
                } },
                React.createElement(FlexWrapper, { pt: commonPaddingValue, pb: commonPaddingValue, gap: isMobileView ? '16px' : '4px', alignItems: "center", flexDirection: isMobileView ? 'column' : 'row', justifyContent: isMobileView ? undefined : 'space-between', isFullWidth: true },
                    React.createElement(FlexWrapper, { gap: "6px", isFullWidth: Boolean(isMobileView), alignItems: "flex-start" },
                        React.createElement(CheckboxStyled, { isRightToLeft: isRightToLeft, checked: isCheckboxChecked, onChange: onApplyProductToFilter }),
                        React.createElement("div", null,
                            React.createElement(RegularTextLevel3, { as: "span" }, t('productsGrid_showPartsAndAccessories_checkbox')),
                            React.createElement(RegularTextLevel3Styled, { weight: 500, as: "span" }, productName))),
                    React.createElement(FlexWrapper, { alignItems: "center", gap: "12px", isFullWidth: Boolean(isMobileView) },
                        React.createElement(Button, { width: !isMobileView ? 'auto' : '100%', label: t('productsGrid_changeTheModel_button'), size: SIZE_40, hasIconButton: TRAILING_ICON, iconComponent: Edit, buttonVariant: GHOST_VARIANT, isRightToLeft: isRightToLeft, onClick: onChangeCheckbox }),
                        React.createElement(Tooltip, { title: t('productsGrid_resetModel_tooltip'), placement: isRightToLeft ? TooltipPlacement.ABOVE_LEFT : TooltipPlacement.ABOVE_RIGHT },
                            React.createElement(Button, { size: SIZE_40, hasIconButton: ICON_ONLY, iconComponent: CloseIcon, buttonVariant: GHOST_VARIANT, isRightToLeft: isRightToLeft, onClick: onResetProduct, "aria-label": `Button for ${t('productsGrid_resetModel_tooltip')}` })))))));
    }
    return null;
}
CompatibilityPanel.displayName = 'CompatibilityPanel_AEMComponent';
